<template>
  <div>
    <v-autocomplete
      v-model="boat"
      :label="$t('components.selectors.boatSelector.selectBoat')"
      :items="boatOptions"
      :menu-props="{ maxHeight: '400' }"
      @input.native="loadBoats()"
      :search-input.sync="boatSearch"
      color="primary"
      return-object
      :clearable="clearable"
      autocomplete="off"
      :item-text="formattedBoatName"
      no-filter
      @change="handleChange"
      @click:clear="handleClear"
      @blur="handleClear"
    >
      <template v-slot:item="{ item }">
        <span class="mr-2">
          {{ formattedBoatName(item) }}
        </span>
        <v-spacer></v-spacer>
        <span v-if="!item.has_maintenance_permission">{{
          $t("components.selectors.boatSelector.noPermission")
        }}</span>
      </template>
      <template v-slot:selection="{ item }">
        <span class="mr-1"> {{ formattedBoatName(item) }} </span>
      </template>
    </v-autocomplete>

    <div v-if="showSelectedBoat">
      <v-row v-for="(boat, index) in boats" :key="index">
        <v-col cols="9" class="ml-6">
          {{ formattedBoatName(boat) }}
        </v-col>
        <v-col cols="1">
          <v-btn @click="removeBoat(boat)" icon color="red"
            ><v-icon>mdi-delete</v-icon></v-btn
          >
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import api from "@/utils/api";

export default {
  props: {
    initialBoatUuid: {
      type: String,
      default: String,
    },
    showBoatName: {
      type: Boolean,
      default: false,
    },
    showSelectedBoat: {
      type: Boolean,
      default: true,
    },
    maintenanceContent: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    selectFirst: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    boatOptions: [],
    boatSearch: "",
    boats: [],
    timeout: null,
    boat: {},
  }),

  created() {
    this.loadBoats(true)
      .then((resp) => {
        if (this.initialBoatUuid.length !== 0) {
          let boat = this.boatOptions.find((element) => {
            return element.uuid === this.initialBoatUuid;
          });

          if (this.maintenanceContent && boat.disabled) {
            boat = {};
          }

          this.boat = boat;
          this.handleChange(boat);
        } else {
          if (this.maintenanceContent && this.selectFirst) {
            let boat = this.boatOptions.find((item) => {
              return !item.disabled;
            });

            if (typeof boat === "undefined") {
              return;
            }

            this.boat = boat;
            this.handleChange(boat);
          }
        }
        //NOTE: This makes sure that the parent component knows that the component data is loaded
        this.$emit("loaded", true);
      })
      .catch((err) => {
        this.$emit("loaded", true);
      });
  },

  methods: {
    handleClear() {
      this.search = "";
      this.loadBoats(false);
    },
    handleChange(value = {}) {
      if (Object.keys(value).length !== 0) {
        this.$emit("change", value);
        this.boats.push(value);
      } else {
        this.$emit("change", null);
      }
    },
    formattedBoatName(item) {
      if (Object.keys(item).length === 0) {
        return;
      }

      if (item && !this.showBoatName) {
        return `${item.model.brand_name} ${item.model.model} #${item.slot_number}`;
      } else if (this.showBoatName) {
        return item.boat_name;
      } else {
        return;
      }
    },
    removeBoat(item) {
      let index = this.boats.findIndex((boat) => boat.uuid === item.uuid);
      this.boats.splice(index, 1);
    },

    loadBoat(boatUuid) {
      api.getBoat(boatUuid).then((resp) => {
        this.search = resp.data.boat_name;
      });
    },

    loadBoats(initalLoad = false) {
      let fetchBoats = (params) => {
        return new Promise((resolve, reject) => {
          this.boatSearch = this.boatSearch ? this.boatSearch : "";
          api
            .maintenanceBoatsOverviewAutocomplete(
              {
                search: this.boatSearch,
                ...params,
              },
              this.maintenanceContent
            )
            .then((resp) => {
              if (this.maintenanceContent) {
                this.boatOptions = resp.data.results.map((element) => {
                  return {
                    ...element,
                    disabled: !element.has_maintenance_permission,
                  };
                });
              } else {
                this.boatOptions = resp.data.results;
              }
              resolve();
            });
        });
      };

      if (initalLoad)
        return fetchBoats({ crm_boat_uuid: this.initialBoatUuid });

      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        return fetchBoats();
      }, 300); // delay
    },
  },
};
</script>
